/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Auto_Select_Next_EventInputs */

const en_options_editor_auto_select_next_event = /** @type {(inputs: Options_Editor_Auto_Select_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto Select Next Event On Start Time Update`)
};

const fr_options_editor_auto_select_next_event = /** @type {(inputs: Options_Editor_Auto_Select_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélection automatique du prochain événement lors de la mise à jour du TC de début`)
};

const de_options_editor_auto_select_next_event = /** @type {(inputs: Options_Editor_Auto_Select_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatische Auswahl des nächsten Ereignisses bei Aktualisierung der Startzeit`)
};

const it_options_editor_auto_select_next_event = /** @type {(inputs: Options_Editor_Auto_Select_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona automaticamente l'evento successivo all'aggiornamento dell'ora di inizio`)
};

const ru_options_editor_auto_select_next_event = /** @type {(inputs: Options_Editor_Auto_Select_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоматический выбор следующего события при обновлении времени начала.`)
};

const es_options_editor_auto_select_next_event = /** @type {(inputs: Options_Editor_Auto_Select_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar automáticamente el próximo evento al actualizar la hora de inicio`)
};

const zh_cn2_options_editor_auto_select_next_event = /** @type {(inputs: Options_Editor_Auto_Select_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开始时间更新时自动选择下一个事件`)
};

const ja_options_editor_auto_select_next_event = /** @type {(inputs: Options_Editor_Auto_Select_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開始時間の更新時に次のイベントを自動選択`)
};

const hi_options_editor_auto_select_next_event = /** @type {(inputs: Options_Editor_Auto_Select_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रारंभ समय अपडेट होने पर अगले इवेंट का स्वतः चयन`)
};

const pt_pt2_options_editor_auto_select_next_event = /** @type {(inputs: Options_Editor_Auto_Select_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleção automática do próximo evento na atualização da hora de início`)
};

/**
* | output |
* | --- |
* | "Auto Select Next Event On Start Time Update" |
*
* @param {Options_Editor_Auto_Select_Next_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_auto_select_next_event = /** @type {((inputs?: Options_Editor_Auto_Select_Next_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Auto_Select_Next_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_editor_auto_select_next_event(inputs)
	if (locale === "de") return de_options_editor_auto_select_next_event(inputs)
	if (locale === "it") return it_options_editor_auto_select_next_event(inputs)
	if (locale === "ru") return ru_options_editor_auto_select_next_event(inputs)
	if (locale === "es") return es_options_editor_auto_select_next_event(inputs)
	if (locale === "zh-CN") return zh_cn2_options_editor_auto_select_next_event(inputs)
	if (locale === "ja") return ja_options_editor_auto_select_next_event(inputs)
	if (locale === "hi") return hi_options_editor_auto_select_next_event(inputs)
	if (locale === "pt-PT") return pt_pt2_options_editor_auto_select_next_event(inputs)
	return en_options_editor_auto_select_next_event(inputs)
});